import { Skeleton } from "primereact/skeleton";
import React from "react";


const PurchaseOrderMobileItem = () =>{
    return(
        <div className="border-round border-1 surface-border p-2 h-9rem mb-2">
            <div className="flex flex-column gap-2">
                {/* <div className="flex gap-2">
                    <div className=" flex flex-1 align-items-center justify-content-center" style={{ width: "20%"}}>
                        <Skeleton shape="circle" size="3rem" className="mr-2"></Skeleton>
                    </div>
                    <div className="flex flex-column gap-3" style={{ width: "70%"}}>
                        <Skeleton width="80%" height="0.7rem"></Skeleton>
                        <Skeleton width="80%" height="0.7rem"></Skeleton>
                    </div>
                </div> */}
                 <div className="flex mb-3">
                    <Skeleton shape="circle" size="4rem" className="mr-2"></Skeleton>
                    <div className="mt-2">
                        <Skeleton width="10rem" className="mb-2"></Skeleton>
                        <Skeleton width="5rem" className="mb-2"></Skeleton>
                        <Skeleton height=".5rem"></Skeleton>
                    </div>
                </div>
                <div className="flex flex-column justify-content-center align-items-center gap-2 px-2">
                    <Skeleton width="100%" height="0.7rem"></Skeleton>
                    <Skeleton width="100%" height="0.7rem"></Skeleton>
                </div>
                {/* <Skeleton width="80%" height="0.7rem"></Skeleton> */}

                
            </div>
        </div>
    )
}
export default PurchaseOrderMobileItem;